export const RULES = {
    strict: {
        label: "Strict Auto Selection",
        icon: "mdi:shield",
    },
    relaxed: {
        label: "Relaxed Auto Selection",
        icon: "mdi:justice",
    },
    moderate: {
        label: "Moderate Auto Selection",
        icon: "ph:list-magnifying-glass",
    },
}

export const LAWS = {
    english: "English Legislation",
    welsh: "Welsh Legislation",
    northernIreland: "Northern Ireland Legislation",
    scottish: "Scottish Legislation",
}

export const LEGACY_LAWS = {
    ...LAWS,
    healthcare: "Healthcare",
    mothballing: "Mothballing",
    reactivation: "Reactivation",
    originalTypes: "Use Unrefined Types",
}

export const FACILITY_TYPES = { healthcare: "Healthcare", mothballing: "Mothballing", reactivation: "Reactivation" }

export const SCHEDULE_LIBRARY_PREFERENCE_LABELS = {
    all: "All Libraries",
    core_only: "SFG20 Library Only",
    custom_only: "Custom Library Only",
    custom_preferred: "Custom Library Preferred",
    core_preferred: "SFG20 Library Preferred",
}

export const SCHEDULE_LIBRARY_PREFERENCE_TOOLTIPS = {
    all: "Current behaviour. AI considers both libraries equally.",
    core_only: "AI maps against the standard SFG20 schedule library, ignoring custom schedules.",
    custom_only: "AI maps against the account's custom schedules, ignoring core SFG20 schedules.",
    custom_preferred:
        "AI considers both libraries but prefers custom schedules when there is a close match between custom and core.",
    core_preferred: "AI considers both libraries but prefers core SFG20 schedules when there is a close match.",
}

export const SETTINGS_DEFAULT = {
    originalTypes: false,
    mappingRule: "strict",
    scheduleLibraryPreference: "all",
    english: false,
    welsh: false,
    scottish: false,
    northernIreland: false,
    healthcare: false,
    mothballing: false,
    reactivation: false,
}
